export const getWeekFromPeriodId = periodId => periodId.slice(7);
